import React from 'react';
import { Box } from "@mui/material";
import Navbar from "@/components/home/Navbar";
import DepartmentIndicatorManager from '@/components/indicators/DepartmentIndicatorManager';

const DepartmentIndicatorPage: React.FC = () => {
  return (
    <Box>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <DepartmentIndicatorManager />
      </Box>
    </Box>
  );
};

export default DepartmentIndicatorPage;

